import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/app/[locale]/partners/[slug]/partner.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/node_modules/next/dist/client/link.js");
